import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import _ from 'lodash'
import jQuery from 'jquery'
import select2Factory from 'select2'
import 'select2/dist/css/select2.css'

import App from './App.vue'
import router from './router'
import './services/api' // Axios configuration
import './styles/main.css'

console.log('Main.js loaded');

// Global libraries
window._ = _
window.$ = window.jQuery = jQuery

// Initialize Select2: factory(root, jQuery) attaches select2 to jQuery
select2Factory(window, jQuery)

// Create Vue app
const app = createApp(App)
console.log('App created');

// Create Pinia store
const pinia = createPinia()

// Use plugins
app.use(pinia)
app.use(router)
app.use(VueSweetalert2, {
  confirmButtonColor: '#10b981',
  cancelButtonColor: '#ef4444'
})

// Global error handler
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue Error:', err, info)
  console.error('Error stack:', err.stack)
}

// Global warning handler
app.config.warnHandler = (msg, instance, trace) => {
  console.warn('Vue Warning:', msg, trace)
}

// Global mixin for Lucide icons - defensive check for createIcons
const safeCreateIcons = () => {
  if (window.lucide && typeof window.lucide.createIcons === 'function') {
    window.lucide.createIcons()
  }
}
app.mixin({
  mounted() {
    this.$nextTick(safeCreateIcons)
  },
  updated() {
    this.$nextTick(safeCreateIcons)
  }
})
// Mount app
console.log('About to mount app');
try {
  app.mount('#app')
  console.log('App mounted successfully.');
} catch (error) {
  console.error('Failed to mount app:', error);
  console.error('Error stack:', error.stack);

  // Fallback: show error message
  document.body.innerHTML = `
    <div style="padding: 20px; text-align: center; font-family: sans-serif;">
      <h1 style="color: red;">App Failed to Load</h1>
      <p>Please check the console for more details.</p>
      <p>Error: ${error.message}</p>
    </div>
  `;
}

